import type { WizardStep } from './import-wizard.logic';

/** Back and forward between mapping and checking. Hidden on the first and last steps. */
export function WizardActions({
  step,
  canCommit,
  onBack,
  onForward,
}: {
  step: WizardStep;
  /** A check has run and said there is something to write. */
  canCommit: boolean;
  onBack: () => void;
  onForward: () => void;
}) {
  if (step !== 'map' && step !== 'check') return null;

  return (
    <div className="c-form-actions c-form-actions--wizard">
      <button
        type="button"
        className="c-button c-button--secondary c-button--md"
        onClick={onBack}
        disabled={step === 'map'}
      >
        Back
      </button>
      <button
        type="button"
        className="c-button c-button--primary c-button--md"
        onClick={onForward}
        // Step 3 writes, so it is only reachable once a check has run and
        // said there is something to write.
        disabled={step === 'check' && !canCommit}
      >
        {step === 'map' ? 'Check the rows' : 'Continue to import'}
      </button>
    </div>
  );
}
